import APIClient from '@/shared/http/clients/api'

const resourceName = 'QMARelatorio'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAllReport = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetAllReport/`, data, config)
const GetAllQmaReport = (limit, index, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetAllQmaReport?limit=${limit}&index=${index}`, data, config)
const GetQmaItem = (fluxo, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetQmaItem/${fluxo}`, data, config)
const GetRelatorioQuantidadeQMA = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/GetRelatorioQuantidadeQMA`, data, config)

const reportQmaRepository = {
  GetAllReport,
  GetAllQmaReport,
  GetQmaItem,
  GetRelatorioQuantidadeQMA
}

export default reportQmaRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/qmaReportRepository.js